import NumerexRoot from './Root.vue';
import NumerexCreate from './views/NumerexCreate.vue';
import NumerexEdit from './views/NumerexEdit.vue';
import NumerexList from './views/NumerexList.vue';

export default {
  path: 'gerador/numerex',
  name: 'admin-numerex',
  component: NumerexRoot,
  redirect: '/novo',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-numerex-list',
      component: NumerexList,
    },
    {
      path: 'novo/',
      name: 'admin-numerex-new',
      component: NumerexCreate,
    },
    {
      path: ':puzzleId',
      name: 'admin-numerex-edit',
      component: NumerexEdit,
    },
  ],
};
